'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _colors = require('HubStyleTokens/colors');

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _UIIllustration = require('UIComponents/image/UIIllustration');

var _UIIllustration2 = _interopRequireDefault(_UIIllustration);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmptyShoppingCartText = (0, _styledComponents2.default)(_Small2.default).withConfig({
  displayName: 'EmptyShoppingCart__EmptyShoppingCartText'
})(['width:100%;max-width:140px;color:', ';text-align:center;'], _colors.EERIE);

var EmptyShoppingCartContainer = (0, _styledComponents2.default)(_UIFlex2.default).withConfig({
  displayName: 'EmptyShoppingCart__EmptyShoppingCartContainer'
})(['height:330px;color:', ';'], _colors.BATTLESHIP);

function EmptyShoppingCart() {
  return _react2.default.createElement(
    EmptyShoppingCartContainer,
    {
      direction: 'column',
      align: 'center',
      justify: 'center'
    },
    _react2.default.createElement(_UIIllustration2.default, {
      name: 'store-disabled',
      width: '125px',
      className: 'm-bottom-4'
    }),
    _react2.default.createElement(
      EmptyShoppingCartText,
      null,
      _react2.default.createElement(_FormattedMessage2.default, { message: 'bundles.shoppingCart.emptyCart' })
    )
  );
}

exports.default = EmptyShoppingCart;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/shopping-cart/EmptyShoppingCart.js
// module id = 707
// module chunks = 3 4